import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const AlertMessage = ({ type = 'danger', message = ''}) => {
  if (!message) return null;

  return (
    <div className={`alert alert-${type} alert-dismissible fade show`} role="alert">
      
     
        <p>{message}</p>
      
     
    </div>
  );
};

export default AlertMessage;
